todos-table
  section.app-table
    header.app-table-header
      .row
        .col-12.col-md-11 { opts.locale.header.value.label }
        .col-12.col-md-1.text-right
    .app-table-body
      .row(each="{ opts.items }")
        .col-12
          .alert.alert-success(if="{done}")
            i.feather.icon-check &nbsp;
            a(href="{link}") { value }
          .alert.alert-warning(if="{!done}")
            a(href="{link}") { value }
        .col-12.col-md-11
          .order.order-props(if="{todable.type == 'Order'}")
            a.job_no(href="{todable.href}")
              | { todable.job_no }
            b.client_name
              | { todable.client_name }
            span.product_official
              span.product_name
                | { todable.product_name }
              span.product_id
                | { todable.product_product_id }
        .col-12.col-md-1.text-right(if="{!done}")
          forms-todos-save(tag-scope="{ this.tagScope }" action="/todos/{id}" method="PATCH")
  shared-paginate(tag-scope="{this.tagScope}.paginate")
  script(type="typescript").
    this.mixin('table');
  style(scoped).
    :scope {
      display: block;
    }
